import { CommonModule } from '@angular/common';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';
import { __awaiter } from 'tslib';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/compressor-config.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-image-compress';
function CompressorConfig() { }
if (false) {
    /** @type {?|undefined} */
    CompressorConfig.prototype.orientation;
    /** @type {?|undefined} */
    CompressorConfig.prototype.ratio;
    /** @type {?|undefined} */
    CompressorConfig.prototype.quality;
    /** @type {?|undefined} */
    CompressorConfig.prototype.enableLogs;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-image-compressor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageCompressorService {
    /**
     * @param {?} imageCompressor
     */
    constructor(imageCompressor) {
        this.imageCompressor = imageCompressor;
    }
    /**
     * @param {?} file
     * @param {?=} config
     * @return {?}
     */
    compressFile(file, config = { orientation: DOC_ORIENTATION.Up, ratio: 50, quality: 50, enableLogs: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const reader = new FileReader();
            return new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => {
                reader.onerror = (/**
                 * @return {?}
                 */
                () => {
                    reader.abort();
                    reject(new DOMException("Problem parsing input file."));
                });
                reader.onload = (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => __awaiter(this, void 0, void 0, function* () {
                    /** @type {?} */
                    const image = event.target.result;
                    /** @type {?} */
                    const sizeOfOriginalImage = this.imageCompressor.byteCount(image) / (1024 * 1024);
                    /** @type {?} */
                    const imgResultAfterCompress = yield this.imageCompressor.compressFile(image, config.orientation, config.ratio, config.quality);
                    /** @type {?} */
                    const sizeOFCompressedImage = this.imageCompressor.byteCount(imgResultAfterCompress) / (1024 * 1024);
                    /** @type {?} */
                    const imageFile = this.dataURLtoFile(imgResultAfterCompress, file.name);
                    if (config.enableLogs) {
                        console.warn('Size in bytes is now:', sizeOfOriginalImage);
                        console.warn('Size in bytes after compression:', sizeOFCompressedImage);
                    }
                    resolve(imageFile);
                }));
                reader.readAsDataURL(file);
            }));
        });
    }
    /**
     * @private
     * @param {?} dataurl
     * @param {?} filename
     * @return {?}
     */
    dataURLtoFile(dataurl, filename) {
        /** @type {?} */
        const arr = dataurl.split(',');
        /** @type {?} */
        const mime = arr[0].match(/:(.*?);/)[1];
        /** @type {?} */
        const bstr = atob(arr[1]);
        /** @type {?} */
        let n = bstr.length;
        /** @type {?} */
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }
}
ImageCompressorService.ɵfac = function ImageCompressorService_Factory(t) { return new (t || ImageCompressorService)(ɵngcc0.ɵɵinject(ɵngcc1.NgxImageCompressService)); };
/** @nocollapse */
ImageCompressorService.ctorParameters = () => [
    { type: NgxImageCompressService }
];
/** @nocollapse */ ImageCompressorService.ɵprov = ɵɵdefineInjectable({ factory: function ImageCompressorService_Factory() { return new ImageCompressorService(ɵɵinject(NgxImageCompressService)); }, token: ImageCompressorService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ImageCompressorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.NgxImageCompressService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ImageCompressorService.prototype.imageCompressor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-image-compressor.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxImageCompressorModule {
}
NgxImageCompressorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxImageCompressorModule });
NgxImageCompressorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxImageCompressorModule_Factory(t) { return new (t || NgxImageCompressorModule)(); }, providers: [
        NgxImageCompressService,
        ImageCompressorService
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxImageCompressorModule, { imports: function () { return [CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxImageCompressorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                exports: [],
                declarations: [],
                providers: [
                    NgxImageCompressService,
                    ImageCompressorService
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-image-compressor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ImageCompressorService, NgxImageCompressorModule };

//# sourceMappingURL=ngx-image-compressor.js.map